import React from 'react';
import { Box, Typography, Link, SxProps, Theme } from '@mui/material';

const ICON_SRC = `${process.env.PUBLIC_URL ?? ''}/assets/images/icon.png`;

export interface ReleasepilotAffiliationProps {
  /** Smaller icon and caption text (e.g. admin sidebar). */
  compact?: boolean;
  /** Text colors: use onDark on gradients / purple bars; onLight in drawer or white cards. */
  variant?: 'onDark' | 'onLight';
  sx?: SxProps<Theme>;
}

/**
 * Brand line: Whatzneu is part of Releasepilot (with Releasepilot icon).
 */
export const ReleasepilotAffiliation: React.FC<ReleasepilotAffiliationProps> = ({
  compact = false,
  variant = 'onLight',
  sx,
}) => {
  const onDark = variant === 'onDark';
  const iconSize = compact ? 20 : 28;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: compact ? 0.75 : 1.25,
        flexWrap: 'wrap',
        ...sx,
      }}
    >
      <Box
        component="img"
        src={ICON_SRC}
        alt="Releasepilot"
        sx={{
          width: iconSize,
          height: iconSize,
          objectFit: 'contain',
          flexShrink: 0,
          borderRadius: 0.5,
        }}
      />
      <Typography
        variant={compact ? 'caption' : 'body2'}
        sx={{
          color: onDark ? 'rgba(255, 255, 255, 0.92)' : 'text.secondary',
          lineHeight: 1.4,
          fontSize: compact ? '0.7rem' : undefined,
        }}
      >
        Whatzneu is part of{' '}
        <Link
          href="https://releasepilot.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontWeight: 600,
            color: onDark ? '#fff' : 'primary.main',
            textDecoration: 'underline',
            textUnderlineOffset: 2,
            '&:hover': { opacity: onDark ? 0.9 : 0.85 },
          }}
        >
          Releasepilot
        </Link>
      </Typography>
    </Box>
  );
};

export default ReleasepilotAffiliation;
